import React, { useContext, useEffect, useState } from 'react';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { LoginContext } from '../../../App';
import { fetchFrameworkData, fetchFrameworksDataPaged } from '../../../services/b2b-frameworks-apiService';
import { fetchAPIDataWhileSettingState } from '../../b2b-common/helpers';
import B2BTable from '../../b2b-common/B2BTable';
import './FrameworksTable.css';

const FrameworksTable = ({ frameworkSuite, onSelectedFramework }) => {
    const { loginData } = useContext(LoginContext);
    const [loadingRowId, setLoadingRowId] = useState(null);
    const [error, setError] = useState(null);
    const [frameworks, setFrameworks] = useState(null);
    const [loadingFrameworks, setLoadingFrameworks] = useState(false);
    const [selectedFramework, setSelectedFramework] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagesCount, setPagesCount] = useState(1);

    const headers = [
        { label: 'Id', align: 'center' },
        { label: 'Acronym', align: 'left' },
        { label: 'Name label', align: 'left' },
        { label: '# Indicators', align: 'center' },
        { label: 'Has secondary?', align: 'center' },
    ];

    const rows = frameworks && frameworks.content ? frameworks.content.map((fw) => ({
        id: fw.frameworkId,
        cells: [
            { content: `${fw.frameworkId}`, align: 'center' },
            { content: `${fw.frameworkAcronym}`, align: 'left' },
            { content: `${fw.frameworkName_label}`, align: 'left' },
            { content: `${fw.indicatorsCount}`, align: 'center' },
            {
                content: (
                    fw.hasSecondaryFrameworks ? (
                        <CheckBoxIcon className="icon checked" />
                    ) : (
                        <CheckBoxOutlineBlankIcon className="icon" />
                    )
                ), align: 'center'
            },
        ]
    })) : [];

    const fetchFramework = async (frameworkId) => {
        setLoadingRowId(frameworkId);
        try {
            const paramsArray = [
                frameworkSuite,
                frameworkId,
                loginData.accessToken,
                4,      // depth
                true,  // fwAddImages
                false,  // levelNsAddImages
            ];
            const fw = await fetchAPIDataWhileSettingState(fetchFrameworkData, paramsArray, null);
            return fw;
        } catch (error) {
            setError(error.message);
        } finally {
            setLoadingRowId(null);
        }
    }

    const fetchAllFrameworksPaged = async (suite, setFrameworks, page, pageSize) => {
        setLoadingFrameworks(true);
        try {
            const paramsArray = [
                suite,
                page,
                pageSize,
                loginData.accessToken,
                true, // countB2bIndicators
            ];
            const fws = await fetchAPIDataWhileSettingState(fetchFrameworksDataPaged, paramsArray, null);
            setFrameworks(fws);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoadingFrameworks(false);
        }
    };

    useEffect(() => {
        fetchAllFrameworksPaged(frameworkSuite, setFrameworks, 0, 10);
        onSelectedFramework(null);
    }, [loginData, frameworkSuite]);

    const handlePageChange = (page) => {
        fetchAllFrameworksPaged(frameworkSuite, setFrameworks, page, 10);
    };

    const handleSelectRow = async (rowInTable) => {
        const fw = await fetchFramework(rowInTable.id);
        //console.log("Selected framework: ", fw);
        if (fw)
            onSelectedFramework(fw);
    }

    return (
        (frameworks && frameworks.content &&
            < B2BTable
                pagesCount={pagesCount}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                headers={headers} rows={rows}
                onRowClick={handleSelectRow}
                rowLoading={loadingRowId}
                tableLoading={loadingFrameworks}
                className={"frameworks-list-table"} />
        )
    );
};

export default FrameworksTable;